import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { keyboardEventPassthroughHandler } from "utils/keyboardEventPassthroughHandler";
import styles from "./ViewStoryArrowComponentStyles.css";

export default function ViewStoryArrowComponent(props) {
  return (
    <span
      className={classnames(styles.root, styles.inline, {
        [styles.standardSize]: !props.scaling,
        [styles.scalingSize]: props.scaling,
      })}
      onClick={props.onClick}
      onKeyUp={keyboardEventPassthroughHandler(props.onClick)}
      role="button"
      tabIndex={0}
    >
      <span className={styles.normalPlayIcon} />
    </span>
  );
}

ViewStoryArrowComponent.propTypes = {
  onClick: PropTypes.func,
  scaling: PropTypes.bool.isRequired,
};
